var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrsLogo = function SvgTrsLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40.1459854,
    viewBox: "0 0 411.0 165.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1.2011211411411211e+28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557,0 L557,259 L0,259 L0,0 L557,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.1199113113101101e+27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.452,0 C65.702,0 86.159,10.133 86.159,35.856 L63.462,32.426 C60.683125,19.7555833 50.1746675,19.043872 42.8688726,19.0197166 L42.407,19.019 C34.941,19.019 26.28,22.293 26.28,31.646 C26.28,39.909 31.358,41.78 58.087,48.483 C66.001,50.509 89.743,55.655 89.743,80.909 C89.743,101.33 74.512,116.609 45.393,116.609 C21.502,116.609 0,104.448 0,77.012 L22.696,80.909 C25.086,95.564 37.629,97.59 46.289,97.59 C54.503,97.59 67.046,95.095 67.046,83.716 C67.046,60.019 3.583,75.296 3.583,33.674 C3.583,10.758 24.19,0 43.452,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 4.555955211748103e+22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.437,0 C48.074,0 48.935,0.074 49.998,0.217 C51.09,0.366 52.277,0.57 53.523,0.824 C54.781,1.082 55.95,1.34 57.025,1.596 C58.052,1.842 58.854,2.062 59.361,2.234 C62.092,3.249 64.779,4.434 67.348,5.758 C69.834,7.042 72.336,8.854 74.793,11.151 C77.607,13.754 79.832,16.487 81.406,19.272 C82.987,22.07 84.084,24.85 84.676,27.578 C85.257,29.875 85.55,32.201 85.55,34.49 C85.55,39.385 84.153,44.517 81.395,49.743 C78.669,54.911 73.786,59.567 66.881,63.578 L65.672,64.28 L91.011,113.293 L64.764,113.293 L41.476,68.821 L24.122,68.821 L24.122,113.137 L0,113.137 L0,0 Z M46.7561003,20.5773666 L24.122,20.577 L24.122,48.244 L46.705,48.244 C47.018,48.244 47.497,48.201 48.886,47.884 C49.876,47.66 50.692,47.435 51.361,47.204 C55.171,45.926 57.85,44.003 59.324,41.488 C60.721,39.102 61.429,36.721 61.429,34.41 C61.429,32.102 60.721,29.722 59.324,27.335 C57.858,24.836 55.196,22.865 51.364,21.461 C50.648,21.22 49.805,21.017 48.785,20.842 C47.428,20.609 46.984,20.577 46.705,20.577 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5.511810648117118e+25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.98,0 C65.219,16.497 69.975,37.119 72.692,50.051 C75.486,41.943 79.287,32.353 81.508,24.983 C81.835,23.899 82.358,23.661 83.55,23.668 C91.129,23.714 98.709,23.715 106.289,23.656 C107.084,23.65 108.029,23.308 108.638,22.852 C110.559,21.415 112.353,19.848 114.33,18.221 C116.379,19.632 118.271,21.318 120.193,22.741 C121.222,23.503 122.403,23.446 123.762,23.439 C130.443,23.404 137.125,23.408 143.807,23.412 L143.807,28.304 C136.602,28.298 129.583,28.292 122.195,28.336 C120.564,28.345 119.245,28.055 118.027,27.08 C116.992,26.253 115.763,25.052 114.619,25.052 C113.876556,25.0512778 113.082472,25.7453333 112.357299,26.4632378 L112.027935,26.7938287 C111.866139,26.9575278 111.709,27.117 111.558,27.264 C110.475,28.318 109.262,28.635 107.657,28.616 C101.032,28.541 94.405,28.607 87.78,28.564 C86.629,28.557 86.142,28.849 85.832,29.856 L71.807,69.383 C70.64046,64.24968 69.2090804,57.9365464 67.7814647,51.6328203 L67.5296263,50.5207378 C64.8449328,38.6647296 62.22956,27.08992 61.475,23.728 C60.986,25.025 60.526,26.289 60.395,26.898 C60.116,28.199 59.453,28.627 57.865,28.621 C42.175,28.561 26.485,28.585 10.795,28.585 L0,28.585 L0,23.691 C17.806,23.687 35.612,23.677 53.418,23.734 C55.164,23.74 55.732,23.244 56.156,21.863 C56.8247,19.6883 57.57845,16.87514 58.317404,13.995002 L58.6851858,12.5519972 L58.8672852,11.8312695 C59.3508289,9.91266328 59.8167027,8.02778703 60.2353224,6.34596878 L60.390032,5.725136 C61.20272,2.46832 61.8116,0.1084 61.98,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.2057511039751103e+24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.018,0 L4.018,10.343 L15.083,10.343 L15.083,0 L19.133,0 L19.133,25.49 L15.083,25.49 L15.083,14.168 L4.018,14.168 L4.018,25.49 L0,25.49 L0,0 L4.018,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.1557118056489852e+22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.733,0 L15.733,3.79 L4.017,3.79 L4.017,10.448 L15.04,10.448 L15.04,14.168 L4.017,14.168 L4.017,21.665 L16.228,21.665 L16.228,25.49 L0,25.49 L0,0 L15.733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9.512195116515511e+24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.913,0 L24.251,25.49 L19.742,25.49 L17.366,19.41 L6.789,19.41 L4.446,25.49 L0,25.49 L10.439,0 L13.913,0 Z M12.075,5.456 L8.23,15.62 L15.892,15.62 L12.075,5.456 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9.81121041154911e+25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.017,0 L4.017,21.665 L14.446,21.665 L14.446,25.49 L0,25.49 L0,0 L4.017,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 111985410453955250000
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.001,0 L19.001,3.79 L11.509,3.79 L11.509,25.49 L7.492,25.49 L7.492,3.79 L0,3.79 L0,0 L19.001,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5.211111511397575e+24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.018,0 L4.018,10.343 L15.083,10.343 L15.083,0 L19.133,0 L19.133,25.49 L15.083,25.49 L15.083,14.168 L4.018,14.168 L4.018,25.49 L0,25.49 L0,0 L4.018,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.0311657971165658e+23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.723,0.98186116 C9.972,0.0498611598 12.59,-0.28113884 15.3,0.26186116 C16.136,0.42886116 16.95,0.68386116 17.719,1.01986116 C18.492,1.35686116 19.208,1.77786116 19.845,2.27286116 C20.488,2.77086116 21.047,3.35686116 21.507,4.01286116 L21.707,4.29886116 L18.546,6.87386116 L18.316,6.53686116 C17.781,5.75386116 17.01,5.09386116 16.026,4.57786116 C15.039,4.06186116 13.96,3.79986116 12.817,3.79986116 C11.516,3.79986116 10.333,4.05186116 9.3,4.54886116 C8.262,5.04786116 7.366,5.73886116 6.634,6.60186116 C5.897,7.47186116 5.321,8.49586116 4.92,9.64586116 C4.518,10.7998612 4.314,12.0458612 4.314,13.3488612 C4.314,14.6998612 4.512,15.9768612 4.905,17.1428612 C5.295,18.3028612 5.86,19.3258612 6.585,20.1828612 C7.305,21.0348612 8.196,21.7128612 9.231,22.1998612 C10.263,22.6858612 11.437,22.9328612 12.718,22.9328612 C13.971,22.9328612 15.124,22.6648612 16.142,22.1358612 C17.158,21.6098612 18.01,20.8298612 18.675,19.8168612 L18.89,19.4888612 L22.114,21.8218612 L21.904,22.1248612 C20.95,23.4938612 19.698,24.6188612 18.182,25.4698612 C16.657,26.3238612 14.808,26.7578612 12.685,26.7578612 C10.86,26.7578612 9.151,26.4238612 7.604,25.7668612 C6.057,25.1088612 4.704,24.1748612 3.584,22.9888612 C2.465,21.8048612 1.579,20.3758612 0.948,18.7428612 C0.319,17.1128612 0,15.2978612 0,13.3488612 C0,11.3778612 0.325,9.54986116 0.966,7.91786116 C1.609,6.28286116 2.513,4.86486116 3.655,3.70386116 C4.797,2.54286116 6.165,1.62686116 7.723,0.98186116 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5.205011848101981e+22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.867,0 C9.014,0 10.12,0.127 11.156,0.377 C12.209,0.632 13.146,1.045 13.941,1.606 C14.747,2.176 15.392,2.933 15.858,3.857 C16.323,4.781 16.559,5.914 16.559,7.224 C16.559,9.132 15.991,10.7 14.872,11.884 C13.875,12.939 12.605,13.656 11.089,14.019 L17.69,25.49 L12.858,25.49 L6.917,14.483 L4.017,14.483 L4.017,25.49 L0,25.49 L0,0 Z M7.636,3.685 L4.017,3.685 L4.017,10.832 L7.405,10.832 C8.145,10.832 8.841,10.765 9.472,10.631 C10.085,10.501 10.627,10.289 11.081,10 C11.528,9.716 11.871,9.359 12.128,8.907 C12.38,8.466 12.508,7.899 12.508,7.224 C12.508,6.549 12.38,5.982 12.128,5.54 C11.874,5.095 11.532,4.733 11.113,4.465 C10.682,4.189 10.164,3.989 9.575,3.87 C8.962,3.747 8.31,3.685 7.636,3.685 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5.610712110911551e+27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.733,0 L15.733,3.79 L4.017,3.79 L4.017,10.448 L15.04,10.448 L15.04,14.168 L4.017,14.168 L4.017,21.665 L16.228,21.665 L16.228,25.49 L0,25.49 L0,0 L15.733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.161164956120501e+25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.234,0 L96.234,20.974 L60.68,20.974 L60.68,113.293 L35.87,113.293 L35.87,20.815 L0,20.815 L0,0 L96.234,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.1911399549811598e+24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.562,0 L59.123,30.617 L36.856,30.617 L36.44,30.186 L29.562,23.063 L29.522,23.103 L22.268,30.617 L0,30.617 L18.388,11.572 L29.522,0.041 L29.562,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.0312010711156525e+26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.267,0 L71.609,51.104 L121.328,0 L143.7,0 L71.609,74.166 L0,0 L22.267,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 1.041065598102113e+25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.61,0 L109.528,39.273 L98.395,50.804 L71.61,23.062 L22.267,74.166 L0,74.166 L71.61,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#12011211411411210312212211555)",
    transform: "translate(-72.0 -38.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.2792 38.44579999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0002000000000066393 11.266299999999973)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.1779 7.105427357601002e-15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1119911311310110211211149106)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 89.743,0 89.743,116.609 0,116.609 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.04240000000001 0.8291000000000395)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#45559552117481031105450)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 91.011,0 91.011,113.293 0,113.293 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 45.16720000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55118106481171181035498120)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 143.807,0 143.807,69.383 0,69.383 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.18350000000004 124.01420000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1205751103975110312299103)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.133,0 19.133,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.18409999999997 124.01440000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11557118056489851122117)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.228,0 16.228,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.103 124.01410000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9512195116515510811610998)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 24.251,0 24.251,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.36620000000005 124.01400000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#98112104115491101195397101)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14.446,0 14.446,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.59410000000003 124.01400000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#111985410453955254055)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.001,0 19.001,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.88710000000003 124.01420000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5211111511397574510012150)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.133,0 19.133,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.69990000000007 123.37533884016676)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#103116579711656575049112)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,6.7168493e-15 22.114,6.7168493e-15 22.114,26.7578612 0,26.7578612 0,6.7168493e-15",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.94190000000003 124.01410000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9512195116515510811610998)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 24.251,0 24.251,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.2051 124.01400000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52050118481019811699122)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.69,0 17.69,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(393.41010000000006 124.01400000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5610712110911551100119117105)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.228,0 16.228,25.49 0,25.49 0,0",
    stroke: "none",
    fill: "#1925A9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.9624 0.8293000000000177)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11611649561205011310910253)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 96.234,0 96.234,113.293 0,113.293 0,0",
    stroke: "none",
    fill: "#1925A9"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.59139999999996 43.54900000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1191139954981159712011597)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 59.123,0 59.123,30.617 0,30.617 0,0",
    stroke: "none",
    fill: "#F6B223"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0146000000000015 90.333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#103120107111565257103118118)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 143.7,0 143.7,74.166 0,74.166 0,0",
    stroke: "none",
    fill: "#F6B223"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10410655981021131065495108)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 109.528,0 109.528,74.166 0,74.166 0,0",
    stroke: "none",
    fill: "#F6B223"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trs_logo.21db5fa15525d1e0a2724b510e8205fe.svg";